module.exports = __webpack_public_path__ + "static/media/iguazu-falls-30.fbe73b59.jpg";